jQuery('#billing_email').blur(function() {
    console.log(jQuery(this).val());
    jQuery.ajax({
        method: 'GET',
        url: ajax_object.ajax_url,
        dataType: "json",
        cache: false,
        data: {
            action: 'check_for_user',
            security: ajax_object.ajax_nonce,
            email: jQuery(this).val()
        },
        success : function(response) {
            jQuery('.email-error').remove();
            if(response.data.success == true){
                console.log((response.data.success));
            } else {
                var errorMessage = '';
                    errorMessage += '<ul class="email-error" role="alert">';
                        errorMessage += '<li>A valid SAI account email is required to purchase licenses.</li>';
                    errorMessage += '</ul>';
                jQuery('#billing_email').after(errorMessage);
            }
        }
    });
});
